import { date, object } from 'yup';

export const providerSchema = object().when('$config', ([config], schema) => {
  return config?.formProviderEnabled
    ? schema.required().typeError('Provider is required')
    : schema.nullable().notRequired();
});

export const dateOfServiceSchema = date().when('$config', ([config], schema) => {
  const { dateOfServiceMax, dateOfServiceMin } = config as { dateOfServiceMax?: Date; dateOfServiceMin?: Date };

  const maxSchema = dateOfServiceMax
    ? schema.max(dateOfServiceMax, `Date of Service must be no later than ${dateOfServiceMax.toLocaleDateString()}`)
    : schema;

  const minMaxSchema = dateOfServiceMin
    ? maxSchema.min(
        dateOfServiceMin,
        `Date of Service must be no earlier than ${dateOfServiceMin.toLocaleDateString()}`
      )
    : maxSchema;

  return config?.formDosEnabled
    ? minMaxSchema.required().typeError('Date of Service is required')
    : minMaxSchema.nullable().notRequired();
});

export const formLevelDetailsSchema = object({
  provider: providerSchema,
  dateOfService: dateOfServiceSchema,
});
